
import { ConsultaRequest } from '../../classes/ConsultaRequest'
import consultaService from "../../services/consultaService";
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'formulario',
  components: { VueRecaptcha },
  methods: {
    resetForm () {
      this.consultaRequest = new ConsultaRequest()
      this.resetRecaptcha()
    },
    resetRecaptcha () {
      this.$refs.recaptcha.reset() // Direct call reset method
      this.gRecaptchaResponse = null
    },
    onExpired: function () {
      this.gRecaptchaResponse = null
    },
    onVerify (token) {
      this.gRecaptchaResponse = token
    },
    onSubmit () {
      this.consultaContrato()
    },
    consultaContrato () {
      this.loading = true
      if (!this.gRecaptchaResponse || this.gRecaptchaResponse === undefined) {
        this.$b.nError(`O Captcha deve ser preenchido!`)
        return
      }
      consultaService.consultaContrato(this.consultaRequest, this.gRecaptchaResponse)
        .then(res => {
          if (res.data.code === 99 || res.data.code === 3) {
            this.resetRecaptcha()
            this.$b.nError(`${res.data.message}`)
            return
          }
          if (res.data.data.sistema === 'AMZ') {
            this.$router.push({ name: 'prorrogar-parcelas-amz', params: { propostaResponse: res.data } })
          } else {
            this.$router.push({ name: 'simulacao', params: { propostaResponse: res.data } })
          }
        })
        .catch(err => {
          this.loading = false
          this.$b.nError(`${err.message}`)
        }).finally(() => this.loading = false)
    }
  },
  data () {
    return {
      consultaRequest: new ConsultaRequest(),
      loading: false,
      icon: false,
      gRecaptchaResponse: null,
      siteKey: '6Lf4YeUUAAAAANikeVXItqaHXkfFAA-QJ-oVi56s'
    }
  }
}
